<template>
    <page-title
        title="予定のたまご一覧"
        icon="bi-egg"
    >
    </page-title>

    <section class="section">
        <div class="row align-items-end">
            <div class="col-6">
                <label>学校担当</label>
                <form-select-search
                    v-model="condition.photographer_id"
                    :options="options_employee"
                    empty_option="-- 全て --"
                ></form-select-search>
            </div>
            <div class="col-6">
                <label>学校名</label>
                <form-select-search
                    v-model="condition.school_id"
                    :options="options_school"
                    empty_option="-- 全て --"
                ></form-select-search>
            </div>
            <div class="col-6">
                <label>標準実施月</label>
                <form-select
                    v-model="condition.event_month"
                    :options="event_months"
                    empty_option="-- 全て --"
                ></form-select>
            </div>
            <div class="col-3">
                <button-search
                    @click="search()"
                    :disabled="loading"
                ></button-search>
            </div>
        </div>
    </section>

    <section class="section">
        <inline-loader v-if="loading"></inline-loader>
        <template v-else>
            <template v-if="undecided_schedules.length">
                <table class="table table-striped mb-4">
                    <thead>
                        <tr class="table-primary">
                            <th class="col-3 text-center">次回推定日</th>
                            <th class="col-5 text-center">学校名</th>
                            <th class="col-6 text-center">予定名</th>
                            <th class="col-3 text-center">前回実施日</th>
                            <th class="col-6"></th>
                        </tr>
                    </thead>
                    <tbody>
                        <template v-for="undecided_schedule, index in undecided_schedules" :key="undecided_schedule">
                            <tr :class="{'table-warning': !isThisYear(undecided_schedule)}">
                                <td class="text-center">{{ undecided_schedule.estimated_schedule_date_display }}</td>
                                <td class="text-center">{{ undecided_schedule.school.school_name }}</td>
                                <td class="text-center">{{ undecided_schedule.event.event_name }}</td>
                                <td class="text-center">{{ undecided_schedule.last_schedule.schedule_date_display }}</td>
                                <td>
                                    <button-exec
                                        class="me-5"
                                        text="本登録..."
                                        color="btn-primary"
                                        icon="bi-box-arrow-up-left"
                                        @click="openScheduleModal(undecided_schedule); setTargetUndecidedSchedule(undecided_schedule, index)"
                                    ></button-exec>
                                    <button-exec
                                        class="ms-5"
                                        text="中止..."
                                        color="btn-outline-danger"
                                        icon="bi-dash-circle"
                                        @click="$refs.confirm_cancel.show(); setTargetUndecidedSchedule(undecided_schedule, index)"
                                    ></button-exec>
                                </td>
                            </tr>
                        </template>
                    </tbody>
                    <tfoot></tfoot>
                </table>
                <paginator :meta="paginator" @move="search"></paginator>
            </template>
            <alert-no-record v-else></alert-no-record>
        </template>
    </section>

    <confirm-dialog ref="confirm_cancel" @ok="cancel()">
        <p>この行事を中止してよろしいですか？</p>
    </confirm-dialog>

    <ScheduleModal
        v-if="modal_show"
        v-model="schedule"
        modal_title="スケジュール 本登録"
        @close="toggleModal()"
        @create="remove"
        :equipments="equipments"
        :cars="cars"
        :employees="employees"
        :options_school="options_school"
        :options_employee="options_employee"
        :options_employee_photographer="options_employee_photographer"
        :options_studio="options_studio"
    ></ScheduleModal>

</template>

<script>
import PageTitle from '@/components/PageTitle';
import ScheduleModal from '@/components/schedule/ScheduleModal';
import InlineLoader from '@/components/tools/InlineLoader';
import Paginator from '@/components/tools/Paginator';
import AlertNoRecord from '@/components/tools/AlertNoRecord';
import FormSelect from '@/components/forms/FormSelect';
import FormSelectSearch from '@/components/forms/FormSelectSearch';
import ConfirmDialog from '@/components/tools/ConfirmDialog';
import School from '@/models/entities/school';
import Event from '@/models/entities/event';
import Equipment from '@/models/entities/equipment';
import Employee from '@/models/entities/employee';
import Car from '@/models/entities/car';
import UndecidedSchedule from '@/models/entities/undecided-schedule';
import Schedule from '@/models/entities/schedule';
import IsPhotographer from '@/models/enums/employee/is-photographer';
import ButtonExec from '@/components/buttons/ButtonExec';
import ButtonSearch from '@/components/buttons/ButtonSearch';


export default {
    name: 'UndecidedSchedule',
    components: {
        PageTitle,
        ScheduleModal,
        InlineLoader,
        Paginator,
        AlertNoRecord,
        ConfirmDialog,
        FormSelect,
        FormSelectSearch,
        ButtonExec,
        ButtonSearch

    },
    inject: [
        'startScreenLoading',
        'endScreenLoading',
        'showMessage'
    ],
    data() {
        return {
            loading: 0,

            undecided_schedules: [],

            //モーダル用
            cars: [],
            equipments: [],
            employees: [],
            options_school: [],
            options_employee: [],
            options_employee_photographer: [],
            options_studio: [],

            condition: {
                photographer_id: null,
                school_id: null,
                event_month: null,
                page: 1,
            },
            paginator: {},


            event_months: [
                {key: 1, label: '1月'},
                {key: 2, label: '2月'},
                {key: 3, label: '3月'},
                {key: 4, label: '4月'},
                {key: 5, label: '5月'},
                {key: 6, label: '6月'},
                {key: 7, label: '7月'},
                {key: 8, label: '8月'},
                {key: 9, label: '9月'},
                {key: 10, label: '10月'},
                {key: 11, label: '11月'},
                {key: 12, label: '12月'},
            ],

            target_index: null,
            target_undefined_schedule: new UndecidedSchedule(),

            schedule: new Schedule(),
            modal_show: false,
        }
    },
    mounted() {
        this.fetchAllSchools();
        this.fetchCarList();
        this.fetchEquipmentList();
        this.fetchAllStudiosForOptions();
    },
    methods: {
        fetchAllSchools() {
            this.loading++;
            this.$http.get('/schools/all')
            .then(response => {
                for (let row of response.data) {
                    this.options_school.push({key: row.school_id, label: row.school_name})
                }
                this.fetchAllEmployees();
            })
            .finally(() => {
                this.loading--;
            });
        },
        // 全ての社員取得
        fetchAllEmployees() {
            this.loading++;

            this.$http.get('/employees/all')
            .then(response => {
                for (let row of response.data) {
                    let employee = new Employee(row);
                    this.employees.push(employee);
                    this.options_employee.push({key: employee.photographer_id, label: employee.photographer_name});
                    // カメラマンの社員のみ
                    if (employee.is_photographer === IsPhotographer.PHOTOGRAPHER) {
                        this.options_employee_photographer.push({key: employee.photographer_id, label: employee.photographer_name});
                    }
                }

                this.setConditions();
            })
            .finally(() => {
                this.loading--;
            });
        },
        fetchCarList() {
            this.loading++;
            this.$http.get(`/cars`)
            .then(response => {
                for (let row of response.data) {
                    this.cars.push(new Car(row));
                }
            })
            .finally(() => {
                this.loading--;
            });
        },
        fetchEquipmentList() {
            this.loading++;
            this.$http.get('/equipments')
            .then(response => {
                for (let row of response.data) {
                    this.equipments.push(new Equipment(row));
                }
            })
            .finally(() => {
                this.loading--;
            });
        },
        // 店舗を取得してoptions用に整形
        fetchAllStudiosForOptions() {
            this.options_studio.splice(0);
            this.$http.get('/studios')
            .then(response => {
                for (let row of response.data) {
                    this.options_studio.push({key: row.studio_id, label: row.studio_name});
                }
            });
        },
        setConditions () {
            this.condition = this.$store.getters['condition/merge']('UndecidedSchedule', this.condition);
            this.search();
        },
        //検索
        search(page = 1) {
            this.loading++;
            this.condition.page = page;
            //表示データ初期化
            this.undecided_schedules.splice(0);
            this.$http.get('/undecided-schedules', {
                params: this.condition
            })
            .then(response => {
                for (let row of response.data.data) {
                    this.undecided_schedules.push(new UndecidedSchedule(row));
                }
                //ページネーション用
                this.paginator = response.data.meta;
                //検索条件を保存
                this.$store.commit('condition/setSearchCondition', {
                    page: 'UndecidedSchedule',
                    condition: this.condition
                });
            })
            .finally(() => {
                this.loading--;
            });
        },
        // 今年度かどうか(年度 = 日付の3ヶ月前の年)
        isThisYear(undecided_schedule) {
            // 今年度
            let date = new Date();
            date.setMonth(date.getMonth() - 3);
            let this_year = date.getFullYear();

            // 次回推定日の年度
            let target_date = new Date(undecided_schedule.estimated_schedule_date);
            target_date.setMonth(target_date.getMonth() - 3);
            let target_year = target_date.getFullYear()

            if (this_year === target_year) {
                return true;
            }

            return false
        },
        resetSchedule() {
            this.schedule.schedule_id = null;
            this.schedule.school = new School();
            this.schedule.event = new Event();
            this.schedule.schedule_type = null;
            this.schedule.schedule_date = null;
            this.schedule.schedule_name = null;
            this.schedule.hour_from = null;
            this.schedule.minute_from = null;
            this.schedule.hour_to = null;
            this.schedule.minute_to = null;
            this.schedule.is_unfixed = 0;
            this.schedule.unfixed_type = null;
            this.schedule.has_several_days = 0;
            this.schedule.first_schedule = null;
            this.schedule.end_date = null;
            this.schedule.end_hour = null;
            this.schedule.end_minute = null;
            this.schedule.rain_type = null;
            this.schedule.spare_schedule = new Schedule();
            this.schedule.checked_date = null;
            this.schedule.photographer_number = null;
            this.schedule.transportation = null;
            this.schedule.schedule_place = null;
            this.schedule.contact_person = null;
            this.schedule.contact_tel = null;
            this.schedule.note = null;
            this.schedule.cars.splice(0);
            this.schedule.files.splice(0);
            this.schedule.memos.splice(0);
            this.schedule.equipments.splice(0);
            this.schedule.photographers.splice(0);
            this.schedule.histories.splice(0);
        },
        openScheduleModal(undecided_schedule) {
            this.resetSchedule();
            this.schedule.school = undecided_schedule.school;
            this.schedule.event = undecided_schedule.event;
            this.toggleModal();
        },
        setTargetUndecidedSchedule(undecided_schedule = new UndecidedSchedule(), index = null) {
            this.target_index = index;
            this.target_undefined_schedule = undecided_schedule;
        },
        cancel() {
            this.startScreenLoading();

            this.$http.delete(`/undecided-schedules/${this.target_undefined_schedule.undecided_schedule_id}`)
            .then(() => {
                this.showMessage('今年度の行事を中止にしました');
                this.undecided_schedules.splice(this.target_index, 1);
                this.setTargetUndecidedSchedule();
            })
            .finally(() => {
                this.endScreenLoading();
            });
        },
        remove() {
            this.startScreenLoading();

            this.$http.delete(`/undecided-schedules/${this.target_undefined_schedule.undecided_schedule_id}`)
            .then(() => {
                this.undecided_schedules.splice(this.target_index, 1);
                this.setTargetUndecidedSchedule();
            })
            .finally(() => {
                this.endScreenLoading();
            });
        },
        toggleModal() {
            if (this.modal_show) {
                this.modal_show = false;
            } else {
                this.modal_show = true;
            }
        },

    }
}
</script>

<style scoped>

</style>
